export default "__VITE_ASSET__ef76a228__"